import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "16",
  height: "16",
  x: "2",
  y: "2",
  fill: "#5B268F",
  rx: "2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  "fill-rule": "evenodd",
  d: "M3 12.794V17h14v-3.258l-2.072-2.103a.693.693 0 0 0-.99 0l-1.781 1.808.438.445a.718.718 0 0 1 0 1.005.693.693 0 0 1-.99 0L6.762 9.981a.693.693 0 0 0-.99 0zm8.867-3.847a.94.94 0 0 1-.934.948.94.94 0 0 1-.933-.948.94.94 0 0 1 .933-.947.94.94 0 0 1 .934.947",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#5B268F",
  "fill-rule": "evenodd",
  d: "M16 3H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }